import { HOST } from "../config/api";

export default class UserApiRoute {
  static readonly USER = `${HOST}/api/user`;
  static readonly USER_NOTIFICATION = `${HOST}/api/user-notification`;
  static readonly CREATE = `${HOST}/api/user`;
  static readonly BOOKING = `${HOST}/api/booking`;
  static readonly GET = `${HOST}/api/user`;
  static readonly LOGIN_WITH_EMAIL = `${HOST}/api/login-email`;
  static readonly LOGIN_WITH_PHONE = `${HOST}/api/login-phone`;
  static readonly FORGOT_PASSWORD = `${HOST}/api/forgot-password`;
  static readonly FORGOT_PASSWORD_CODE = `${HOST}/api/forgot-password-reset`;
  static readonly RESET_PASSWORD = `${HOST}/api/reset-password`;
  static readonly PROFILE = `${HOST}/api/user-profile`;
  static readonly PROFILE_SEARCH = `${HOST}/api/profile-search`;
  static readonly PROFILE_SEARCH_LATEST = `${HOST}/api/profile-search-latest`;
  static readonly PHOTO = `${HOST}/api/user-photo`;
  static readonly DELETE_PHOTO = `${HOST}/api/delete-user-photo`;
  static readonly WORKER_PHOTO = `${HOST}/api/worker-photo`;
  static readonly DEBUG = `${HOST}/api/debug`;

  static readonly CITY = `${HOST}/api/city`;
  static readonly CITY_TOP_5_POPULAR = `${HOST}/api/city-top-5-popular`;

  static readonly EDUCATION = `${HOST}/api/education`;
  static readonly EDUCATION_SEARCH = `${HOST}/api/education-search`;

  static readonly SUPPLY_SEARCH = `${HOST}/api/supply-search`;

  static readonly PAYMENT = `${HOST}/api/payment`;
  static readonly PAYMENT_SESSION = `${HOST}/api/payment-session`;
  static readonly PAYMENT_CUSTOMER_PORTAL_SESSION = `${HOST}/api/customer-portal-session`;
}
